module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/middle-banner-9fe14171d6793b8e5329c2a5d62ab1d9.png";